import { useState, useEffect } from "react";
import {
  Row, Col, FormGroup, Label, Input, FormFeedback, Card, CardBody, Button
} from "reactstrap";
import { useFormikContext } from "formik";
import { showSuccess, showError } from "../components/AppToast";
import axios from "axios";
import api from "../api";
import { Info } from "lucide-react";
 
export default function UdfMapping({ slug }) {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = useFormikContext();
  const [availableFields, setAvailableFields] = useState([]);
  const fields = Array.from({ length: 10 }, (_, i) => `UDF${i + 1}`);
 
  useEffect(() => {
    const loadSlugAndFields = async () => {
      try {
        const token = localStorage.getItem("jwt");
              const response = await api.post(
  `${process.env.REACT_APP_BASE_URL_DEV}/forms/slug/init/${slug}`,
          {},
          {
            params: { isActive: "true" },
            headers: { "Content-Type": "application/json" },
          }
        );
 
        const fieldsData = response.data?.form_schema?.fields || [];
        setAvailableFields(fieldsData);
      } catch (err) {
        console.error("Failed to load slug/fields:", err);
      }
    };
 
    if (slug) {
      loadSlugAndFields();
    }
  }, [slug]);
 
  const clearAllFields = () => {
    fields.forEach(field => setFieldValue(field, ""));
    showSuccess("All UDF fields reset to default");
  };
 
  const getAvailableOptions = (currentField) => {
    const chosen = fields
      .filter(f => f !== currentField)
      .map(f => values[f])
      .filter(v => v);
    return availableFields
      .map(f => `${f.label} (${f.id})`)
      .filter(label => !chosen.includes(label));
  };
 
  const handleSubmit = async () => {
    const udfMappings = {};
    let anySelected = false;
 
    fields.forEach(field => {
      if (values[field]) {
        anySelected = true;
        const match = /\((.*?)\)$/.exec(values[field]);
        udfMappings[field] = match ? match[1] : values[field];
      } else {
        udfMappings[field] = "";
      }
    });
 
    if (!anySelected) {
      showError("Nothing is selected. Please map at least one UDF field.");
      return;
    }
 
    try {
      const token = localStorage.getItem("jwt");
      await api.post(
        `${process.env.REACT_APP_BASE_URL_DEV}/forms/slug/${slug}/udf`,
        udfMappings,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      showSuccess("UDF mappings saved successfully!");
      setTimeout(() => {
        window.location.href = "/gfb-admin/my-forms";
      }, 1500);
    } catch (err) {
      console.error("Failed to save UDF mappings:", err);
      showError("Error saving UDF mappings");
    }
  };
 
  return (
    <Card className="mt-3">
      <CardBody>
        <div className="d-flex justify-content-end mb-3">
          <Button type="button" color="danger" size="sm" onClick={clearAllFields}>
            Clear All
          </Button>
        </div>
 
        <Row>
          {fields.map(field => (
            <Col md="6" key={field} className="mb-3">
              <FormGroup>
                <Label>{field.toUpperCase()}</Label>
                <Input
                  type="select"
                  name={field}
                  value={values[field] || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  invalid={touched[field] && !!errors[field]}
                >
                  <option value="">-- Select a field --</option>
                  {getAvailableOptions(field).map((label, idx) => (
                    <option key={idx} value={label}>{label}</option>
                  ))}
                </Input>
                <FormFeedback>{touched[field] && errors[field]}</FormFeedback>
              </FormGroup>
            </Col>
          ))}
        </Row>
 <div className="bulk-notes-card">
          <div className="bulk-notes-header">
            <Info size={16} />
            <span>Note</span>
          </div>
          <ul className="udf-list">
           <li>
  <strong>UDF1–UDF5</strong> support a maximum of 45 characters. For longer values, use <strong>UDF6–UDF10</strong>.
</li>

           
          </ul>
        </div>

        <div className="mt-3 d-flex align-items-center gap-2">
          <Button type="button" color="primary" onClick={handleSubmit}>
            Submit Mappings
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
 